<template>
    <div class="video-response">
        <div v-if="response != null && response[0] && response[0].value" class="video answer">
            <div class="answered-text">
                <span class="watched-date">Seen on {{formatDateTime(response[0].value)}}</span>
                <span class="weighted-middot"> &middot; </span>
                <span class="watch-video">Watch Video</span>
            </div>
            <a class="open-icon" :href="question.video" target="_blank">
                <OpenNewIcon></OpenNewIcon>
            </a>
        </div>
        <div v-else class="no-answer inl-blk">
            <span>Not Answered</span>
        </div>
    </div>
</template>

<script>

import Icons from '../icon'
import formatDateTime from '@/module/util/format-date-time'

export default {   
    name: 'video-partial',

    props: {
        // Content object for this question
		question: {
			type: Object,
			required: true
		},
		response: {
			type: Number,
		},
	},

    methods: {
        formatDateTime
    },

    components: {
        ...Icons
    }
}
</script>

<style lang="scss" scoped>
@import "../style.scss";
.watched-date {
    color: #833E93;
    font-size: 13px;
    font-weight: bold;
}
.watch-video {
    text-decoration: underline;
    color: #666666;
}

.inl-blk {
    display: inline-block;
}
.open-icon {
    margin-left: 10px;
    height: 26px;
    width: 26px;
    margin-top: 9px;
}
.video-response {
    .answer {
        display: inline-flex;
        justify-content: start;
        align-items: center;
        margin-top: -10px;
        .answered-text {
            // padding-top: 5px;

            .weighted-middot {
                font-size: 2em;
                position: relative;
                top: 2px;
            }
        }
    }
}
</style>
